import { render } from "./ExamTemplateUpdate.vue?vue&type=template&id=3015a2ba&scoped=true"
import script from "./ExamTemplateUpdate.vue?vue&type=script&lang=js"
export * from "./ExamTemplateUpdate.vue?vue&type=script&lang=js"

import "./ExamTemplateUpdate.vue?vue&type=style&index=0&id=3015a2ba&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3015a2ba"]])

export default __exports__